export default __webpack_public_path__ + "img/cSKvkxbG.7f7d0e82.svg";